<!-- 隐私声明预览 -->
<template>
  <div class="privacy-preview">
    <p v-if="showTitle" class="privacy-preview__title">{{ $t('lang.k_383001') }}</p>
    <div class="privacy-preview__content">
      <div
        class="privacy-preview__item"
        v-for="(item, index) in optionList"
        :key="`pre_${item.id}`"
      >
        <vh-checkbox
          v-if="!!showCheckbox"
          :true-label="1"
          :false-label="0"
          class="pre-checkbox"
        ></vh-checkbox>
        <pre class="pre-html" v-html="formatPrivacyPreview(item)"></pre>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'PrivacyPreview',
    props: {
      showTitle: {
        type: Boolean,
        default: false
      },
      showCheckbox: {
        type: Number,
        default: 1
      },
      optionList: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    methods: {
      // 生成预览效果
      formatPrivacyPreview(item) {
        let text = item.content || '';
        const subOptions = item?.options || [];
        for (const sub of subOptions) {
          if (sub.color_text && sub.url) {
            let matchPrivacy = text.match(sub.color_text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
            if (matchPrivacy) {
              let joinstr = `<a href="${sub.url}" target="_blank">${matchPrivacy[0]}</a>`;
              text = text.split(matchPrivacy[0]).join(joinstr);
            }
          }
        }
        return text;
      }
    }
  };
</script>
<style lang="less" scoped>
  .privacy-preview {
    &__title {
      font-size: 14px;
      color: #262626;
      margin: 16px 0 8px 0;
    }
    &__content {
      display: flex;
      flex-direction: column;
    }
    &__item {
      flex: 1;
      display: flex;
      flex-direction: row;
      .pre-checkbox {
        padding-right: 8px;
        margin-top: 3px;
      }
      .pre-html {
        flex: 1;
        display: inline-block;
        line-height: 22px;
        font-size: 14px;
        color: #595959;
        ::v-deep a,
        a:active,
        a:visited,
        a:hover {
          color: #3562fa;
        }
      }
    }

    ::v-deep .vh-checkbox {
      display: block;
    }
    pre {
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  }
</style>
